import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import "bridgetown-quick-search"
import "./search.js"

console.info("Bridgetown is loaded!")

document.addEventListener("DOMContentLoaded", () => {
  const $navbarBurger = document.querySelector("#navbar-burger")
  const $navbarClose = document.querySelector("#navbar-close")
  const $navbarMenu = document.querySelector("#navbar-menu")

  if ($navbarBurger && $navbarClose && $navbarMenu) {
    $navbarBurger.addEventListener("click", () => {
      $navbarMenu.classList.remove("hidden")
      $navbarBurger.classList.add("hidden")
      $navbarClose.classList.remove("hidden")
    })

    $navbarClose.addEventListener("click", () => {
      $navbarMenu.classList.add("hidden")
      $navbarBurger.classList.remove("hidden")
      $navbarClose.classList.add("hidden")
    })
  }
})

// In development, Chrome exhausts its 6-connection-per-host pool because
// Bridgetown's live reload SSE connections stay open across navigations.
// Intercept EventSource to close connections on page unload.
if (process.env.NODE_ENV !== "production") {
  const _EventSource = window.EventSource
  const _openSources = []
  window.EventSource = function (...args) {
    const es = new _EventSource(...args)
    _openSources.push(es)
    return es
  }
  window.addEventListener("pagehide", () => {
    _openSources.forEach(es => es.close())
    _openSources.length = 0
  })
}
